/**
 * Public Course Manager
 * Ana sayfa carousel, kurs listesi ve detay sayfası için JavaScript yöneticisi
 */

(function () {
  "use strict";

  const CoursePublic = {
    /**
     * Swiper carousel initialization (Ana sayfa featured courses)
     */
    initSwiper: function () {
      const swiperElement = document.querySelector(".course-swiper");
      if (!swiperElement) return;
      const slidesCount = swiperElement.querySelectorAll(".swiper-slide").length;

      new Swiper(".course-swiper", {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: slidesCount > 3,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
        },
      });
    },

    /**
     * AJAX pagination handler (Kurs listesi)
     * Event delegation kullanarak dinamik içerik için çalışır
     */
    initPagination: function () {
      // Event delegation: content-area'ya listener ekle
      const contentArea = document.querySelector(".content-area");
      if (!contentArea) return;

      // Mevcut listener'ı temizle (çift tıklama önleme)
      contentArea.removeEventListener("click", this._paginationHandler);

      // Yeni listener ekle
      this._paginationHandler = function (e) {
        const target = e.target.closest(".page-item");
        if (!target) return;

        e.preventDefault();

        const page = target.dataset.page;
        if (!page) return;

        CoursePublic.loadPage(page);
      };

      contentArea.addEventListener("click", this._paginationHandler);
    },

    /**
     * Load page via AJAX
     */
    loadPage: function (page) {
      const url = new URL(window.location.href);
      url.searchParams.set("page", page);

      // Önce sayfayı en üste kaydır - kullanıcı hemen görebilmeli
      this.scrollToTop();

      // Loading state göster
      const contentArea = document.querySelector(".content-area");
      if (contentArea) {
        contentArea.style.opacity = "0.5";
        contentArea.style.pointerEvents = "none";
      }

      fetch(url.toString(), {
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      })
        .then((response) => {
          if (!response.ok) throw new Error("Network response was not ok");
          return response.text();
        })
        .then((html) => {
          if (contentArea) {
            contentArea.innerHTML = html;
            contentArea.style.opacity = "1";
            contentArea.style.pointerEvents = "auto";

            // URL'i güncelle
            window.history.pushState({}, "", url.toString());

            // İçerik güncellendikten sonra yukarı kaydır
            setTimeout(() => {
              CoursePublic.scrollToTop();
            }, 50);
          }
        })
        .catch((error) => {
          console.error("Sayfa yüklenirken hata oluştu:", error);
          if (contentArea) {
            contentArea.style.opacity = "1";
            contentArea.style.pointerEvents = "auto";
          }
          if (window.Toast) {
            window.Toast.error("Bağlantı Hatası", "İçerik yüklenirken bir sorun oluştu. Lütfen internet bağlantınızı kontrol edip tekrar deneyin.");
          } else {
            alert("İçerik yüklenirken bir sorun oluştu. Lütfen bağlantınızı kontrol edip tekrar deneyin.");
          }
        });
    },

    /**
     * Sayfayı en üste kaydır
     */
    /**
     * Sayfayı en üste kaydır
     */
    scrollToTop: function () {
      // Ana scroll container'ı bul (core.js'de tanımlı)
      const scrollContainer = document.querySelector(".snap-container");
      const coursesSection = document.querySelector("#courses");

      if (scrollContainer && coursesSection) {
        // Courses section'ın container içindeki pozisyonunu bul
        const sectionTop = coursesSection.offsetTop;
        const headerOffset = 100; // Header payı

        // Container'ı scroll et
        scrollContainer.scrollTo({
          top: sectionTop - headerOffset,
          behavior: "smooth",
        });
      } else {
        // Fallback
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    },

    /**
     * Sidebar filtreleme (Search ve Category)
     */
    initFilters: function () {
      const searchForm = document.querySelector(".search-widget");
      if (searchForm) {
        const searchInput = searchForm.querySelector("input");
        const searchButton = searchForm.querySelector(".search-icon");

        if (searchButton && searchInput) {
          // Mevcut event'leri temizle
          const newSearchButton = searchButton.cloneNode(true);
          searchButton.parentNode.replaceChild(newSearchButton, searchButton);

          const handleSearch = function () {
            const searchTerm = searchInput.value.trim();
            if (searchTerm) {
              // Önce scroll yap
              CoursePublic.scrollToTop();

              // Kısa bir gecikme sonra redirect et
              setTimeout(() => {
                window.location.href = `/Egitimler/Ara?searchTerm=${encodeURIComponent(searchTerm)}`;
              }, 100);
            }
          };

          newSearchButton.addEventListener("click", handleSearch);

          searchInput.addEventListener("keypress", function (e) {
            if (e.key === "Enter") {
              e.preventDefault();
              handleSearch();
            }
          });
        }
      }

      // Category links
      const categoryList = document.querySelector(".category-list");
      if (categoryList) {
        // Event delegation kullan
        categoryList.addEventListener("click", function (e) {
          const link = e.target.closest("a");
          if (!link) return;

          e.preventDefault();

          // Önce scroll yap
          CoursePublic.scrollToTop();

          // Sadece kategori adını al, count kısmını çıkar
          const categoryText = link.childNodes[0].textContent.trim();

          // Kısa bir gecikme sonra redirect et
          setTimeout(() => {
            window.location.href = `/Egitimler/Kategori/${encodeURIComponent(categoryText)}`;
          }, 100);
        });
      }
    },

    /**
     * Detay sayfası tab switching
     */
    initTabs: function () {
      const tabButtons = document.querySelectorAll(".tab-btn");
      const tabContents = document.querySelectorAll(".tab-content");
      if (tabButtons.length === 0) return;

      tabButtons.forEach((button) => {
        button.addEventListener("click", function () {
          const targetId = this.getAttribute("data-tab");
          if (!targetId) return;

          // Update buttons
          tabButtons.forEach((btn) => btn.classList.remove("active"));
          this.classList.add("active");

          // Update contents
          tabContents.forEach((content) => {
            if (content.id === targetId) {
              content.classList.remove("hidden");
            } else {
              content.classList.add("hidden");
            }
          });
        });
      });
    },

    initCurriculum: function () {
      const sections = document.querySelectorAll(".curriculum-section");
      if (!sections.length) return;

      sections.forEach((section, index) => {
        const header = section.querySelector(".section-header");
        if (!header) return;

        // Check if already initialized to prevent double binding
        if (header.dataset.initialized === "true") return;

        header.addEventListener("click", () => {
          const isActive = section.classList.contains("active");

          // Close all others
          sections.forEach((s) => s.classList.remove("active"));

          // Toggle current
          if (!isActive) {
            section.classList.add("active");
          }
        });

        // Mark as initialized
        header.dataset.initialized = "true";
      });
    },

    /**
     * Initialize all
     */
    init: function () {
      this.initSwiper();
      this.initPagination();
      this.initFilters();
      this.initTabs();
      this.initCurriculum();
    },
  };

  // Auto-init on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      CoursePublic.init();
    });
  } else {
    CoursePublic.init();
  }

  window.CoursePublic = CoursePublic;
})();
